export const translations = {
  de: {
    // Navigation
    nav: {
      home: "Home",
      fleet: "Flotte",
      services: "Services",
      about: "Über Uns",
      contact: "Kontakt",
      requestNow: "Jetzt anfragen"
    },
    
    // Hero Section
    hero: {
      title: "Zeit ist Ihr wertvollstes Gut.",
      titleHighlight: "Wir geben sie Ihnen zurück.",
      subtitle: "Erleben Sie Europas effizienteste Light-Jet-Flotte. Exklusive Charterflüge mit der Beechcraft Premier 1 – direkt vom Betreiber, ohne Kompromisse.",
      requestFlight: "Jetzt Flug anfragen",
      discoverFleet: "Die Flotte entdecken"
    },
    
    // About Section
    about: {
      title: "Mehr als eine Airline. Ihr persönlicher Hangar.",
      intro: "Unterscheiden Sie uns von großen Charter-Brokern, die Kunden als \"Nummer im System\" behandeln. Executive Air betont unseren Boutique-Ansatz.",
      description: "Wir sind Eigentümer und keine Vermittler. Unsere Flotte besteht aus drei identischen, perfekt gewarteten Flugzeugen.",
      availability: "Garantierte Verfügbarkeit",
      availabilityText: "Wenn Sie buchen, fliegen Sie genau das Flugzeug, das Sie erwarten. Keine Überraschungen.",
      safety: "Höchste Sicherheitsstandards",
      safetyText: "Wartung und Crew-Training liegen in unserer Hand. Ihre Sicherheit ist unser oberstes Gebot.",
      service: "Persönlicher Service",
      serviceText: "Wir kennen Ihre Präferenzen: Lieblingswein, gewünschte Temperatur an Bord – wir erinnern uns.",
      aircraftCount: "Premier 1 Flugzeuge"
    },
    
    // Fleet Section
    fleet: {
      title: "Die Flotte: The Sports Car of Business Jets",
      subtitle: "Die Beechcraft Premier 1 ist kein gewöhnlicher Light Jet. Dank ihres Rumpfes aus Carbon-Verbundwerkstoff bricht sie die Regeln der Physik.",
      comfort: "Midsize-Komfort",
      comfortText: "Rumpf aus Carbon-Verbundwerkstoff ermöglicht eine breitere und höhere Kabine als bei vergleichbaren Jets. \"Stand-up Cabin\"-Freiheit mit 1,65m Höhe, Platz für bis zu 6 Passagiere.",
      comfortStat: "Kabinenhöhe",
      speed: "Geschwindigkeit",
      speedText: "Reisegeschwindigkeit von über 830 km/h (450 kts) – schneller ans Ziel als die meisten Konkurrenten ihrer Klasse. München nach London ist ein Katzensprung.",
      speedStat: "> 830 km/h",
      avionics: "Modernste Avionik",
      avionicsText: "Die Kabine ist nicht nur geräumiger, sondern auch leiser. Perfekt zum konzentrierten Arbeiten oder Entspannen in absoluter Ruhe.",
      avionicsStat: "Leiseste Kabine"
    },
    
    // Comparison Table
    comparison: {
      title: "Warum Executive Air die klügere Wahl ist",
      feature: "Merkmal",
      broker: "Standard Charter-Broker",
      executiveAir: "Executive Air (Premier 1)",
      aircraft: "Flugzeugtyp",
      aircraftBroker: "Oft Ungewissheit (\"Category: Light Jet\")",
      aircraftEA: "Garantiert Beechcraft Premier 1",
      cabin: "Kabinenraum",
      cabinBroker: "Oft eng (muss gebückt betreten werden)",
      cabinEA: "Geräumigste Kabine der Klasse (Stand-up)",
      speed: "Geschwindigkeit",
      speedBroker: "Durchschnittlich ca. 700 km/h",
      speedEA: "High-Speed Cruise ca. 830 km/h",
      contact: "Ansprechpartner",
      contactBroker: "Call-Center Agenten",
      contactEA: "Direkter Kontakt zum Operations-Team",
      redundancy: "Flotten-Redundanz",
      redundancyBroker: "Variabel",
      redundancyEA: "3 eigene Flugzeuge als Backup"
    },
    
    // Services Section
    services: {
      title: "Ihr Flug, nach Ihren Regeln",
      subtitle: "Mehr als nur Transport – ein maßgeschneidertes Flugerlebnis",
      catering: "Executive Catering",
      cateringText: "Von leichten Snacks bis zum First-Class Menü. Wir richten uns nach Ihrem Geschmack – Ihr Lieblingsrestaurant über den Wolken.",
      pets: "Pets on Board",
      petsText: "Ihr Haustier fliegt selbstverständlich in der Kabine mit – nicht im Frachtraum. Komfort für die ganze Familie.",
      boarding: "15-Minuten Boarding",
      boardingText: "Kein Warten in Warteschlangen. Ankunft am GAT (General Aviation Terminal) und Abflug 15 Minuten später."
    },
    
    // Contact Form
    contactForm: {
      title: "Bereit für den Take-off?",
      subtitle: "Kontaktieren Sie unser Operations Team 24/7 für ein unverbindliches Angebot.",
      name: "Name",
      email: "E-Mail",
      phone: "Telefon",
      passengers: "Anzahl Passagiere",
      from: "Von",
      to: "Nach",
      date: "Wunschdatum",
      message: "Nachricht",
      messagePlaceholder: "Weitere Informationen oder spezielle Wünsche...",
      submit: "Anfrage senden",
      fromPlaceholder: "Abflugort",
      toPlaceholder: "Zielort"
    },
    
    // Footer
    footer: {
      description: "Europas exklusive Premier 1 Flotte. Direkt vom Betreiber.",
      navigation: "Navigation",
      contact: "Kontakt",
      legal: "Rechtliches",
      phone: "+49 (0) XXX XXX XXX",
      email: "ops@executive-air.eu",
      address: "Europa-Allee 62, 54343 Föhren",
      imprint: "Impressum",
      privacy: "Datenschutz",
      terms: "AGB",
      copyright: "© 2025 Executive Air. Alle Rechte vorbehalten."
    }
  },
  
  en: {
    // Navigation
    nav: {
      home: "Home",
      fleet: "Fleet",
      services: "Services",
      about: "About Us",
      contact: "Contact",
      requestNow: "Request Now"
    },
    
    // Hero Section
    hero: {
      title: "Time is your most valuable asset.",
      titleHighlight: "We give it back to you.",
      subtitle: "Experience Europe's most efficient light jet fleet. Exclusive charter flights with the Beechcraft Premier 1 – directly from the operator, without compromise.",
      requestFlight: "Request Flight Now",
      discoverFleet: "Discover the Fleet"
    },
    
    // About Section
    about: {
      title: "More than an airline. Your personal hangar.",
      intro: "Distinguish us from large charter brokers who treat customers as \"just a number in the system\". Executive Air emphasizes our boutique approach.",
      description: "We are owners, not brokers. Our fleet consists of three identical, perfectly maintained aircraft.",
      availability: "Guaranteed Availability",
      availabilityText: "When you book, you fly exactly the aircraft you expect. No surprises.",
      safety: "Highest Safety Standards",
      safetyText: "Maintenance and crew training are in our hands. Your safety is our top priority.",
      service: "Personal Service",
      serviceText: "We know your preferences: favorite wine, desired cabin temperature – we remember.",
      aircraftCount: "Premier 1 Aircraft"
    },
    
    // Fleet Section
    fleet: {
      title: "The Fleet: The Sports Car of Business Jets",
      subtitle: "The Beechcraft Premier 1 is no ordinary light jet. Thanks to its carbon composite fuselage, it breaks the rules of physics.",
      comfort: "Midsize Comfort",
      comfortText: "Carbon composite fuselage enables a wider and taller cabin than comparable jets. \"Stand-up Cabin\" freedom with 1.65m height, space for up to 6 passengers.",
      comfortStat: "Cabin Height",
      speed: "Speed",
      speedText: "Cruise speed of over 830 km/h (450 kts) – faster to your destination than most competitors in its class. Munich to London is a breeze.",
      speedStat: "> 830 km/h",
      avionics: "State-of-the-art Avionics",
      avionicsText: "The cabin is not only more spacious but also quieter. Perfect for focused work or relaxing in absolute peace.",
      avionicsStat: "Quietest Cabin"
    },
    
    // Comparison Table
    comparison: {
      title: "Why Executive Air is the Smarter Choice",
      feature: "Feature",
      broker: "Standard Charter Broker",
      executiveAir: "Executive Air (Premier 1)",
      aircraft: "Aircraft Type",
      aircraftBroker: "Often uncertain (\"Category: Light Jet\")",
      aircraftEA: "Guaranteed Beechcraft Premier 1",
      cabin: "Cabin Space",
      cabinBroker: "Often cramped (must enter stooped)",
      cabinEA: "Most spacious cabin in class (Stand-up)",
      speed: "Speed",
      speedBroker: "Average approx. 700 km/h",
      speedEA: "High-Speed Cruise approx. 830 km/h",
      contact: "Point of Contact",
      contactBroker: "Call Center Agents",
      contactEA: "Direct contact to Operations Team",
      redundancy: "Fleet Redundancy",
      redundancyBroker: "Variable",
      redundancyEA: "3 owned aircraft as backup"
    },
    
    // Services Section
    services: {
      title: "Your Flight, Your Rules",
      subtitle: "More than just transport – a tailored flight experience",
      catering: "Executive Catering",
      cateringText: "From light snacks to first-class menus. We cater to your taste – your favorite restaurant above the clouds.",
      pets: "Pets on Board",
      petsText: "Your pet naturally flies in the cabin with you – not in cargo. Comfort for the whole family.",
      boarding: "15-Minute Boarding",
      boardingText: "No waiting in queues. Arrival at GAT (General Aviation Terminal) and departure 15 minutes later."
    },
    
    // Contact Form
    contactForm: {
      title: "Ready for Take-off?",
      subtitle: "Contact our Operations Team 24/7 for a non-binding quote.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      passengers: "Number of Passengers",
      from: "From",
      to: "To",
      date: "Preferred Date",
      message: "Message",
      messagePlaceholder: "Additional information or special requests...",
      submit: "Send Request",
      fromPlaceholder: "Departure location",
      toPlaceholder: "Destination"
    },
    
    // Footer
    footer: {
      description: "Europe's exclusive Premier 1 fleet. Directly from the operator.",
      navigation: "Navigation",
      contact: "Contact",
      legal: "Legal",
      phone: "+49 (0) XXX XXX XXX",
      email: "ops@executive-air.eu",
      address: "Europa-Allee 62, 54343 Föhren, Germany",
      imprint: "Imprint",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      copyright: "© 2025 Executive Air. All rights reserved."
    }
  }
};
